import * as React from "react";
import { FieldCaption, FieldCaptionProps } from "./FieldCaption";

/**
 * Captions a group of inputs - a row of radio buttons or checkboxes - the
 * way Label captions a single one.
 *
 * Label renders a real <label> around its children, and a <label> with no
 * htmlFor forwards every click to the first control inside it. On a group
 * that means clicking the caption, or any gap in the row, silently picks
 * the first option. The markup was never right for a group either: a
 * <label> may caption only one control, and the inputs webui builds -
 * CheckboxWithLabel and RadioButtonWithLabel - each render a <label> of
 * their own, so wrapping them in another one nested labels inside labels.
 *
 * The caption is tied to the group through aria rather than through the
 * element itself, which names the group for a screen reader without
 * handing it a control to activate. Naming it from the same string the
 * caption is drawn from is what keeps the two from drifting apart.
 *
 * That group is the whole difference from [[FieldCaption]], which captions
 * one field and claims nothing about it.
 */
export const FieldGroupCaption: React.FC<FieldCaptionProps> = ({
  label,
  children,
  ...boxProps
}) => (
  <FieldCaption {...boxProps} role={"group"} aria-label={label} label={label}>
    {children}
  </FieldCaption>
);
